import React from 'react';
import i18n from '../../i18n';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch() {
    /* no stack / internals in the UI */
  }

  render() {
    if (!this.state.hasError) {
      return this.props.children;
    }

    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 p-6">
        <div className="max-w-md text-center space-y-3">
          <h1 className="text-xl font-semibold text-gray-900">{i18n.t('pageErrorTitle')}</h1>
          <p className="text-gray-600">{i18n.t('pageErrorBody')}</p>
          <div className="flex justify-center gap-3">
            <button type="button" className="btn btn-primary" onClick={() => window.location.reload()}>
              {i18n.t('reloadPage')}
            </button>
            <a href="/" className="btn btn-secondary">
              {i18n.t('goHome')}
            </a>
          </div>
        </div>
      </div>
    );
  }
}
